/**
 * channelsLineup.tsx
 */
import ChannelListTemplate from '../../templates/channel/channelsLineup';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { eventsSelector } from '@shared/store/slices/events.slice';
import { useAppSelector } from '@shared/store/hooks';

export default function ChannelsLineup() {
  const { currentEvents } = useAppSelector(eventsSelector);
  const { currentChannel, favouriteChannels } =
    useAppSelector(channelsSelector);
  const currentIndex =
    favouriteChannels?.findIndex((item) => item.id === currentChannel?.id) || 0;

  return (
    <>
      {favouriteChannels?.length && (
        <ChannelListTemplate
          channelsData={favouriteChannels}
          currentChannel={currentChannel}
          currentEvents={currentEvents}
          currentIndex={currentIndex}
        />
      )}
    </>
  );
}
